module.exports = __webpack_public_path__ + "assets/img/wavy-line-2.svg";